import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Lore.css';
import { useTranslation } from 'react-i18next';
// Importando iconos
import { FaSpaceShuttle, FaUniversity, FaGlobeAmericas, FaBook, FaSearch, FaTimes } from 'react-icons/fa';
import { GiCrossedSwords, GiAlienSkull, GiBirdMask, GiDiploma } from 'react-icons/gi';
import { MdExplore } from 'react-icons/md';
import EventSearch from './EventSearch';
import Starmap from './Starmap';
import { getSystemsForYear, getSystemDiscoveries } from '../data/contextos/evolucion_sistemas';
import palarNestImage from '../assets/PalarNestPanoramico.webp';
import franklinYeungImage from '../assets/FranklinYeung.webp';
import tanaNovachekImage from '../assets/TanaNovachekPanoramico.webp';
import lore2Image from '../assets/Lore2.webp';
import nacimientoPalarNest from '../assets/nacimientopalarnest.webp';
import encuentroConFranklin from '../assets/encuentroconfranklin.webp';
import ataqueAFranklin from '../assets/ataqueafranklin.webp';
import elPrimerContrato from '../assets/elprimercontrato.webp';
import fundacionCorvusCorax from '../assets/fundaciondecorvuscorax.webp';
import primeraAsambleaCorvusNocta from '../assets/primeraasambleacorvusnocta.webp';
import laEmboscadaEnPyro from '../assets/laemboscadaenpyro.webp';
import encuentroConTanaNovachek from '../assets/encuentrocontananovachek.webp';
import elNuevoRumbo from '../assets/elnuevorumbo.webp';
import retiroDePalarNest from '../assets/retirodepalarnest.webp';
import liderazgoTanaNovachek from '../assets/liderazgodetananovachek.webp';
import oberonCrisis from '../assets/OberonUriel.webp';
import magnusMission from '../assets/MagnusBoreaOdyssa.webp';
import magnusExpansion from '../assets/MagnusBoreaOdyssa.webp';
import oretaniImage from '../assets/OretaniIII.webp';
import tanaBirth from '../assets/TanaNovachek.webp';
import tanaAcademy from '../assets/TanaAcademia.webp';
import tanaAcademyExcellence from '../assets/TanaAcademia18.webp';
import tanaConsolidation from '../assets/TanaNovachek50.webp';
import tanaGraduationBg from '../assets/TanaNovachekGraduacion.webp';
import tanaInteligencia from '../assets/TanaInteligencia.webp';
import tanaContrainteligencia from '../assets/TanaContrainteligencia.webp';
import tanaTraicion from '../assets/TanaTraicion.webp';
import colaboracionTanaPalar from '../assets/ColaboracionTanaPalar.webp';
import tanaNoctaFederation from '../assets/TanaNoctaFederation.webp';
import tana4Image from '../assets/Tana4.webp';
import tanaManoDerechaImage from '../assets/TanaManoDerecha.webp';
import amberKoshobeImage from '../assets/AmberKoshobe.webp';
import amberEnlistImage from '../assets/AmberEnlist.webp';
import amberCampoBatallaImage from '../assets/AmberCampoBatalla.webp';
import amberCiudadanoLabImage from '../assets/AmberCiudadanoLab.webp';
import koshobe4Image from '../assets/Koshobe4.webp';
import corvusActualidadImage from '../assets/CorvusActualidad.webp';

/** Mismo código de color que el Starmap: especie/facción del sistema */
const DISCOVERY_SYSTEM_COLORS = {
    uee: '#4169E1',
    developing: '#5B9BD5',
    unclaimed: '#87CEEB',
    vanduul: '#8B0000',
    xian: '#2E8B57',
    banu: '#CD853F',
    tevarin: '#888888'
};

const Lore = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const timelineRef = useRef(null);
    const headerRef = useRef(null); // Referencia para el header
    const [activeEvent, setActiveEvent] = useState("0"); // Inicializar en el primer evento
    const hasInitialized = useRef(false);
    const [showSearch, setShowSearch] = useState(false); // Estado para mostrar/ocultar el buscador
    
    // Filtros activos (integrados en la leyenda)
    const [activeFilters, setActiveFilters] = useState(['corvus', 'tana', 'amber', 'sc']);
    
    // Estado para búsqueda integrada
    const [searchTerm, setSearchTerm] = useState('');
    
    const [carouselStates, setCarouselStates] = useState({}); // Estado para los carruseles
    const [rightPanelCollapsed, setRightPanelCollapsed] = useState(false);
    const [, forceUpdate] = useState();
    
    // Función para navegar entre eventos visibles y separadores de era (con soporte para carruseles)
    const navigateEvents = (direction) => {
        if (filteredEvents.length === 0) return;
        
        const activeEventIndex = parseInt(activeEvent);
        const currentEvent = timelineEvents[activeEventIndex];
        
        if (!currentEvent) return;
        
        // Obtener eventos agrupados por año
        const groupedEvents = groupEventsByYear();
        
        // Si el evento actual no es separador de era, verificar si está en un carrusel
        if (currentEvent.type !== 'era-separator') {
            const currentYear = currentEvent.year;
            const yearEvents = groupedEvents[currentYear] || [];
            
            // Si hay múltiples eventos en este año (carrusel)
            if (yearEvents.length > 1) {
                const currentCarouselIndex = carouselStates[currentYear] || 0;
                
                // Intentar navegar dentro del carrusel primero
                let newCarouselIndex;
                const yearKeyCarousel = String(currentYear);
                if (direction === 'next') {
                    newCarouselIndex = currentCarouselIndex + 1;
                    // Si no hemos llegado al final del carrusel, navegar dentro
                    if (newCarouselIndex < yearEvents.length) {
                        const newEvent = yearEvents[newCarouselIndex];
                        setCarouselStates(prev => ({
                            ...prev,
                            [yearKeyCarousel]: newCarouselIndex
                        }));
                        setActiveEvent(newEvent.realIndex.toString());
                        return;
                    }
                } else { // prev
                    newCarouselIndex = currentCarouselIndex - 1;
                    // Si no hemos llegado al principio del carrusel, navegar dentro
                    if (newCarouselIndex >= 0) {
                        const newEvent = yearEvents[newCarouselIndex];
                        setCarouselStates(prev => ({
                            ...prev,
                            [yearKeyCarousel]: newCarouselIndex
                        }));
                        setActiveEvent(newEvent.realIndex.toString());
                        return;
                    }
                }
            }
        }
        
        // Si llegamos aquí, navegar al siguiente/anterior año o separador de era
        let currentIndexInFiltered = filteredEvents.findIndex(event => 
            event.year === currentEvent.year && 
            event.type === currentEvent.type &&
            (event.title === currentEvent.title || event.era === currentEvent.era)
        );
        
        if (currentIndexInFiltered === -1) currentIndexInFiltered = 0;
        
        // Calcular nuevo índice en filteredEvents (saltar a diferente año)
        let newIndexInFiltered;
        if (direction === 'next') {
            // Buscar el siguiente año diferente
            newIndexInFiltered = currentIndexInFiltered;
            do {
                newIndexInFiltered = (newIndexInFiltered + 1) % filteredEvents.length;
            } while (
                newIndexInFiltered !== currentIndexInFiltered && 
                filteredEvents[newIndexInFiltered].year === currentEvent.year &&
                filteredEvents[newIndexInFiltered].type !== 'era-separator'
            );
        } else {
            // Buscar el año anterior diferente
            newIndexInFiltered = currentIndexInFiltered;
            do {
                newIndexInFiltered = newIndexInFiltered === 0 ? filteredEvents.length - 1 : newIndexInFiltered - 1;
            } while (
                newIndexInFiltered !== currentIndexInFiltered && 
                filteredEvents[newIndexInFiltered].year === currentEvent.year &&
                filteredEvents[newIndexInFiltered].type !== 'era-separator'
            );
        }
        
        const targetEvent = filteredEvents[newIndexInFiltered];
        const newActiveEventIndex = timelineEvents.findIndex(event => 
            event.year === targetEvent.year && 
            event.type === targetEvent.type &&
            (event.title === targetEvent.title || event.era === targetEvent.era)
        );
        
        if (newActiveEventIndex === -1) return;

        // Calcular índice final y estado del carrusel: una sola actualización para evitar desincronía
        let finalActiveIndex = newActiveEventIndex;
        const yearKeyStr = String(targetEvent.year);

        if (targetEvent.type !== 'era-separator') {
            const targetYearEvents = groupedEvents[targetEvent.year] || [];
            if (targetYearEvents.length > 1) {
                const carouselIndex = direction === 'next' ? 0 : targetYearEvents.length - 1;
                const eventToShow = targetYearEvents[carouselIndex];
                finalActiveIndex = eventToShow.realIndex;
                setCarouselStates(prev => ({
                    ...prev,
                    [yearKeyStr]: carouselIndex
                }));
            }
        }

        setActiveEvent(finalActiveIndex.toString());

        // Scroll al elemento que realmente estamos mostrando
        setTimeout(() => {
            const element = document.querySelector(`[data-index="${finalActiveIndex}"]`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    };
    
    // Función auxiliar para verificar si un evento es visible
    const isEventVisible = (event) => {
        return event.type === 'era-separator' || activeFilters.includes(event.type);
    };
    
    // Función para manejar la selección de un evento desde el buscador
    const handleEventSelect = (selectedEvent) => {
        // Buscar el evento en el timeline
        const timelineIndex = timelineEvents.findIndex(event => 
            event.title === selectedEvent.title && 
            event.year === selectedEvent.year &&
            event.type !== 'era-separator'
        );
        
        if (timelineIndex !== -1) {
            setActiveEvent(timelineIndex.toString());
            
            // Scroll al evento
            setTimeout(() => {
                const element = document.querySelector(`[data-index="${timelineIndex}"]`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);
        }
    };

    // Función para abrir el buscador
    const handleOpenSearch = () => {
        setShowSearch(true);
    };

    // Función para cerrar el buscador
    const handleCloseSearch = () => {
        setShowSearch(false);
    };
    
    // Forzar re-render cuando cambie el idioma
    useEffect(() => {
        forceUpdate({});
    }, [i18n.language]);

    // Efecto para sincronizar el estado del carrusel con el evento activo
    useEffect(() => {
        if (activeEvent !== null) {
            const groupedEvents = groupEventsByYear();
            Object.entries(groupedEvents).forEach(([yearKey, events]) => {
                if (events.length > 1) {
                    const eventIndex = events.findIndex(e => e.realIndex.toString() === activeEvent);
                    if (eventIndex !== -1 && carouselStates[yearKey] !== eventIndex) {
                        setCarouselStates(prev => ({
                            ...prev,
                            [yearKey]: eventIndex
                        }));
                    }
                }
            });
        }
    }, [activeEvent]);

    // Al entrar a la página Lore (p. ej. desde el menú del header), ubicar al inicio de la línea temporal
    useEffect(() => {
        if (location.pathname === '/lore') {
            setActiveEvent('0');
            window.scrollTo(0, 0);
        }
    }, [location.pathname]);

    // Escuchar el evento de reset del BackToTop
    useEffect(() => {
        const handleResetActiveEvent = (event) => {
            // console.log('🔄 Reseteando activeEvent a:', event.detail.index);
            setActiveEvent(event.detail.index.toString());
        };
        
        window.addEventListener('resetActiveEvent', handleResetActiveEvent);
        
        return () => {
            window.removeEventListener('resetActiveEvent', handleResetActiveEvent);
        };
    }, []);



    // Función para obtener la imagen correspondiente a cada evento
    const getEventImage = (eventKey) => {
        const imageMap = {
            'palar_birth': palarNestImage,
            'franklin_meeting': [palarNestImage, franklinYeungImage],
            'franklin_attack': franklinYeungImage,
            'first_contract': palarNestImage,
            'oberon_crisis': palarNestImage,
            'corvus_corax': palarNestImage,
            'oretani_operations': palarNestImage,

            'pyro_ambush': palarNestImage,
            'magnus_mission': palarNestImage,
            'palar_retirement': palarNestImage,
            'magnus_expansion': palarNestImage,
            'first_assembly': [palarNestImage, tanaNovachekImage],
            'palar_death': palarNestImage,
            'tana_leadership': tanaNovachekImage,
            'corvus_consolidation': tanaNovachekImage,
            'modern_corvus': lore2Image,
            'tana_birth': tanaNovachekImage,
            'tana_academy': tanaNovachekImage,
            'tana_excellence': tanaNovachekImage,
            'tana_graduation': tanaNovachekImage,
            'tana_intelligence': tanaNovachekImage,
            'tana_undercover': tanaNovachekImage,
            'tana_betrayal': tanaNovachekImage,
            'tana_meeting_palar': [palarNestImage, tanaNovachekImage],
            'tana_nocturna_federation': tanaNovachekImage,
            'tana_collaboration': [palarNestImage, tanaNovachekImage],
            'tana_right_hand': [palarNestImage, tanaNovachekImage],
            'corvus_present': palarNestImage,
            'amber_birth': amberKoshobeImage,
            'amber_equivalence': amberKoshobeImage,
            'amber_citizenship': amberKoshobeImage,
            'amber_service': amberKoshobeImage,
            'amber_enrc_foundation': amberKoshobeImage,
            'amber_fcn_collaboration': amberKoshobeImage,
            'amber_tevarin_war': amberKoshobeImage,
            'amber_corvus_integration': amberKoshobeImage

        };
        return imageMap[eventKey] || null;
    };

    // Obtener era y descripción para un año (mismos rangos que los separadores de era)
    const getEraForYear = (year) => {
        if (year == null || typeof year !== 'number') return { era: '', description: '' };
        if (year < 0) return { era: 'Era Antigua', description: 'Civilizaciones ancestrales y primeras expansiones' };
        if (year < 2300) return { era: 'Era de Expansión Humana', description: 'Primeros viajes espaciales y colonización de otros mundos' };
        if (year < 2800) return { era: 'Era Tevarin y Messer', description: 'Guerras Tevarin y dictadura Messer' };
        if (year < 2900) return { era: 'Era Moderna Temprana', description: 'Reconstrucción y democratización de la UEE' };
        return { era: 'Era Moderna', description: 'Era contemporánea de Star Citizen' };
    };

    // Función para crear el array de eventos con las traducciones actuales
    const timelineEvents = useMemo(() => {
        console.log('🔧 Construyendo timeline simplificado...');
        
        // Array final simplificado
        const timeline = [];
        
        // ERA ANTIGUA
        timeline.push({
            type: 'era-separator',
            year: -1000000,
            era: 'Era Antigua',
            description: 'Civilizaciones ancestrales y primeras expansiones'
        });
        
        // Eventos de era antigua (años negativos hasta -1)
        const ancientEvents = Object.entries(t('lore.events', { returnObjects: true }))
            .map(([key, event]) => ({
                year: event.year,
                type: event.type,
                eventKey: `lore.events.${key}`,
                title: event.title,
                content: event.content,
                image: getEventImage(key)
            }))
            .filter(e => e.year < 0)
            .sort((a, b) => a.year - b.year);

        timeline.push(...ancientEvents);
        
        // ERA DE EXPANSIÓN HUMANA
        timeline.push({
            type: 'era-separator',
            year: 0,
            era: 'Era de Expansión Humana',
            description: 'Primeros viajes espaciales y colonización de otros mundos'
        });
        
        // Eventos de expansión (0-2300)
        const expansionEvents = Object.entries(t('lore.events', { returnObjects: true }))
            .map(([key, event]) => ({
                year: event.year,
                type: event.type,
                eventKey: `lore.events.${key}`,
                title: event.title,
                content: event.content,
                image: getEventImage(key)
            }))
            .filter(e => e.year >= 0 && e.year < 2300)
            .sort((a, b) => a.year - b.year);
        
        timeline.push(...expansionEvents);
        
        // ERA TEVARIN
        timeline.push({
            type: 'era-separator',
            year: 2300,
            era: 'Era Tevarin y Messer',
            description: 'Guerras Tevarin y dictadura Messer'
        });
        
        // Eventos Tevarin/Messer (2300-2800)
        const tevarinEvents = Object.entries(t('lore.events', { returnObjects: true }))
            .map(([key, event]) => ({
                year: event.year,
                type: event.type,
                eventKey: `lore.events.${key}`,
                title: event.title,
                content: event.content,
                image: getEventImage(key)
            }))
            .filter(e => e.year >= 2300 && e.year < 2800)
            .sort((a, b) => a.year - b.year);
        
        timeline.push(...tevarinEvents);
        
        // ERA MODERNA TEMPRANA
        timeline.push({
            type: 'era-separator',
            year: 2800,
            era: 'Era Moderna Temprana',
            description: 'Reconstrucción y democratización de la UEE'
        });
        
        // Eventos modernos tempranos (2800-2900)
        const modernEarlyEvents = Object.entries(t('lore.events', { returnObjects: true }))
            .map(([key, event]) => ({
                year: event.year,
                type: event.type,
                eventKey: `lore.events.${key}`,
                title: event.title,
                content: event.content,
                image: getEventImage(key)
            }))
            .filter(e => e.year >= 2800 && e.year < 2900)
            .sort((a, b) => a.year - b.year);
        
        timeline.push(...modernEarlyEvents);
        
        // ERA MODERNA
        timeline.push({
            type: 'era-separator',
            year: 2900,
            era: 'Era Moderna',
            description: 'Era contemporánea de Star Citizen'
        });
        
        // Eventos modernos (2900+)
        const modernEvents = Object.entries(t('lore.events', { returnObjects: true }))
            .map(([key, event]) => ({
                year: event.year,
                type: event.type,
                eventKey: `lore.events.${key}`,
                title: event.title,
                content: event.content,
                image: getEventImage(key)
            }))
            .filter(e => e.year >= 2900)
            .sort((a, b) => a.year - b.year);
        
        timeline.push(...modernEvents);
        
        console.log('✅ Timeline construido:', timeline.length, 'eventos');
        console.log('📊 Primeros 10 eventos:', timeline.slice(0, 10).map(e => ({ year: e.year, type: e.type, title: e.title || e.era })));
        
        return timeline;
    }, [t, i18n.language]);
    
    // Obtener los eventos filtrados
    const filteredEvents = useMemo(() => {
        let filtered = timelineEvents.filter(event => 
            activeFilters.includes(event.type) || event.type === 'era-separator'
        );
        
        // Aplicar filtro de búsqueda si hay término de búsqueda
        if (searchTerm.trim()) {
            const searchLower = searchTerm.toLowerCase();
            filtered = filtered.filter(event => {
                // Buscar en título, contenido y año
                const searchableText = [
                    event.title || '',
                    event.content || '',
                    event.year?.toString() || '',
                    event.era || ''
                ].join(' ').toLowerCase();
                
                return searchableText.includes(searchLower);
            });
        }
        
        // Debug: verificar que la Era Antigua esté al principio
        // console.log('TimelineEvents[0]:', timelineEvents[0]);
        // console.log('FilteredEvents[0]:', filtered[0]);
        
        return filtered;
    }, [activeFilters, timelineEvents, searchTerm]);

    // Sistemas del mapa estelar según el año del evento activo (evolución por timeline)
    const starmapSystemsForYear = useMemo(() => {
        const index = parseInt(activeEvent, 10);
        const event = timelineEvents[index];
        const year = event?.year != null ? Number(event.year) : 2271;
        return getSystemsForYear(year);
    }, [activeEvent, timelineEvents]);

    // Efecto para inicializar el estado del carrusel
    useEffect(() => {
        const groupedEvents = groupEventsByYear();
        const newCarouselStates = {};
        
        Object.entries(groupedEvents).forEach(([yearKey, events]) => {
            if (events.length > 1) {
                newCarouselStates[yearKey] = 0;
            }
        });
        
        setCarouselStates(newCarouselStates);
            }, [activeFilters, timelineEvents]);

    // Función para detectar eventos compartidos entre personajes
    const getSharedEvents = useMemo(() => {
        const sharedEvents = [];
        const eventGroups = {};
        
        // Agrupar eventos por año
        timelineEvents.forEach((event, index) => {
            if (event.type !== 'era-separator') {
                if (!eventGroups[event.year]) {
                    eventGroups[event.year] = [];
                }
                eventGroups[event.year].push({ ...event, originalIndex: index });
            }
        });
        
        // Encontrar años con múltiples eventos de diferentes personajes
        Object.entries(eventGroups).forEach(([year, events]) => {
            const characterTypes = [...new Set(events.map(e => e.type))];
            if (characterTypes.length > 1) {
                sharedEvents.push({
                    year: parseInt(year),
                    events: events,
                    characters: characterTypes
                });
            }
        });
        
        return sharedEvents;
    }, [timelineEvents]);
    
    // Memoizar los índices de los eventos especiales
    const specialEventIndices = useMemo(() => {
        const indices = {};
        timelineEvents.forEach((event, index) => {
            if (event.type === 'corvus' || event.type === 'tana' || event.type === 'amber') {
                switch (event.eventKey) {
                    case 'lore.events.palar_birth':
                        indices.birth = index;
                        break;
                    case 'lore.events.franklin_meeting':
                        indices.franklinMeeting = index;
                        break;
                    case 'lore.events.franklin_attack':
                        indices.franklinAttack = index;
                        break;
                    case 'lore.events.first_contract':
                        indices.firstContract = index;
                        break;
                    case 'lore.events.oberon_crisis':
                        indices.oberonCrisis = index;
                        break;
                    case 'lore.events.corvus_corax':
                        indices.corvusCorax = index;
                        break;
                    case 'lore.events.oretani_operations':
                        indices.oretaniOperations = index;
                        break;

                    case 'lore.events.pyro_ambush':
                        indices.pyroAmbush = index;
                        break;
                    case 'lore.events.magnus_mission':
                        indices.magnusMission = index;
                        break;
                    case 'lore.events.palar_retirement':
                        indices.palarRetirement = index;
                        break;
                    case 'lore.events.magnus_expansion':
                        indices.magnusExpansion = index;
                        break;
                    case 'lore.events.first_assembly':
                        indices.firstAssembly = index;
                        break;
                    case 'lore.events.palar_death':
                        indices.palarDeath = index;
                        break;
                    case 'lore.events.tana_leadership':
                        indices.tanaLeadership = index;
                        break;
                    case 'lore.events.corvus_consolidation':
                        indices.corvusConsolidation = index;
                        break;
                    case 'lore.events.corvus_present':
                        indices.corvusPresent = index;
                        break;
                    case 'lore.events.tana_birth':
                        indices.tanaBirth = index;
                        break;
                    case 'lore.events.tana_academy':
                        indices.tanaAcademy = index;
                        break;
                    case 'lore.events.tana_excellence':
                        indices.tanaExcellence = index;
                        break;
                    case 'lore.events.tana_graduation':
                        indices.tanaGraduation = index;
                        break;
                    case 'lore.events.tana_intelligence':
                        indices.tanaIntelligence = index;
                        break;
                    case 'lore.events.tana_undercover':
                        indices.tanaUndercover = index;
                        break;
                    case 'lore.events.tana_betrayal':
                        indices.tanaBetrayal = index;
                        break;
                    case 'lore.events.tana_meeting_palar':
                        indices.tanaMeetingPalar = index;
                        break;
                    case 'lore.events.tana_nocturna_federation':
                        indices.tanaNocturnaFederation = index;
                        break;
                    case 'lore.events.tana_collaboration':
                        indices.tanaCollaboration = index;
                        break;
                    case 'lore.events.tana_right_hand':
                        indices.tanaRightHand = index;
                        break;
                    case 'lore.events.amber_birth':
                        indices.amberBirth = index;
                        break;
                    case 'lore.events.amber_equivalence':
                        indices.amberEquivalence = index;
                        break;
                    case 'lore.events.amber_citizenship':
                        indices.amberCitizenship = index;
                        break;
                    case 'lore.events.amber_service':
                        indices.amberService = index;
                        break;
                    case 'lore.events.amber_enrc_foundation':
                        indices.amberEnrcFoundation = index;
                        break;
                    case 'lore.events.amber_fcn_collaboration':
                        indices.amberFcnCollaboration = index;
                        break;
                    case 'lore.events.amber_tevarin_war':
                        indices.amberTevarinWar = index;
                        break;
                    case 'lore.events.amber_corvus_integration':
                        indices.amberCorvusIntegration = index;
                        break;

                }
            }
        });
        
        // Debug: verificar los índices de los eventos de Tana
        // console.log('specialEventIndices:', indices);
        
        return indices;
    }, [timelineEvents]);
    
    // Función para obtener el icono según el título o contenido del evento
    const getEventIcon = (event) => {
        // Si es un separador de era, no mostramos icono
        if (event.type === 'era-separator') return null;
        
        const title = event.title ? event.title.toLowerCase() : '';
        const year = event.year ? event.year : '';
        
        // Para los eventos de Corvus Nocta
        if (event.type === 'corvus') {
            if (title.includes('fundación') || title.includes('nacimiento')) {
                return <GiDiploma className="event-icon" />;
            } else if (title.includes('ataque') || title.includes('emboscada')) {
                return <GiCrossedSwords className="event-icon" />;
            } else if (title.includes('asamblea') || title.includes('encuentro')) {
                return <FaUniversity className="event-icon" />;
            } else {
                return <GiBirdMask className="event-icon" />; // Icono por defecto para Corvus
            }
        } 
        // Para los eventos de Tana Novachek
        else if (event.type === 'tana') {
            if (title.includes('nacimiento') || title.includes('graduación')) {
                return <GiDiploma className="event-icon" />;
            } else if (title.includes('academia') || title.includes('excelencia')) {
                return <FaUniversity className="event-icon" />;
            } else if (title.includes('inteligencia') || title.includes('contraespionaje')) {
                return <GiCrossedSwords className="event-icon" />;
            } else {
                return <GiBirdMask className="event-icon" />; // Icono por defecto para Tana
            }
        } 
        // Para los eventos de Star Citizen
        else if (event.type === 'sc') {
            if (title.includes('guerra') || title.includes('batalla') || title.includes('conflicto')) {
                return <GiCrossedSwords className="event-icon" />;
            } else if (title.includes('descubrimiento') || title.includes('exploración')) {
                return <MdExplore className="event-icon" />;
            } else if (title.includes('contacto') || title.includes('alien')) {
                return <GiAlienSkull className="event-icon" />;
            } else if (title.includes('colonización') || title.includes('asentamiento')) {
                return <FaGlobeAmericas className="event-icon" />;
            } else if (title.includes('fundación') || title.includes('creación') || title.includes('formación')) {
                return <GiDiploma className="event-icon" />;
            } else {
                return <FaSpaceShuttle className="event-icon" />; // Icono por defecto para SC
            }
        }
        return null;
    };
    

    

    
    // Nota: Removido reset automático de activeEvent para evitar conflictos con navegación
    

    
    // Función para activar manualmente un evento
    const handleEventClick = (index) => {
        setActiveEvent(index.toString());
        
        // FORZAR SCROLL AL EVENTO SELECCIONADO
        setTimeout(() => {
            const eventElement = document.querySelector(`[data-index="${index}"]`);
            if (eventElement) {
                // Scroll suave al evento
                eventElement.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center' 
                });
                
                // FORZAR ACTIVACIÓN DE LA TARJETA
                setTimeout(() => {
                    // Primero limpiar todos los elementos activos anteriores
                    document.querySelectorAll('.event-detail.active, .shared-event-detail.active').forEach(detail => {
                        detail.classList.remove('active');
                    });
                    document.querySelectorAll('.timeline-event-point.active, .shared-event-point.active').forEach(point => {
                        point.classList.remove('active');
                    });

                    // Ahora activar el elemento seleccionado
                    const eventDetail = eventElement.querySelector('.event-detail, .shared-event-detail');
                    if (eventDetail) {
                        eventDetail.classList.add('active');
                        // También activar el punto del evento
                        const eventPoint = eventElement.querySelector('.timeline-event-point, .shared-event-point');
                        if (eventPoint) {
                            eventPoint.classList.add('active');
                        }
                    }
                }, 100);
            }
        }, 50);
    };

    // Función para mantener visible un detalle mientras el cursor está sobre él
    const handleDetailHover = (index, isEntering) => {
        if (isEntering) {
            setActiveEvent(index.toString());
        }
        // No hacer nada si el cursor sale - dejamos que el observer maneje esto
    };
    
    // Función para mantener los detalles visibles al hacer click en ellos
    const handleDetailClick = (index, event) => {
        // Prevenir la propagación para que no se cierre si se hace click fuera
        event.stopPropagation();
        // Mantener activo este detalle
        setActiveEvent(index.toString());
    };
    
    // Nota: Removido manejador de click fuera para evitar resets no deseados de activeEvent
    useEffect(() => {
        const handleOutsideClick = (event) => {
            // Click fuera deshabilitado para evitar interferencia con navegación
            return;
        };
        
        // Añadir el event listener
        document.addEventListener('click', handleOutsideClick);
        
        // Limpieza
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [activeEvent]);
    
    // Función para comprobar si un elemento está cerca del header
    const isElementNearHeader = (element) => {
        const headerHeight = document.querySelector('header') ? 
            document.querySelector('header').offsetHeight : 80;
        
        const rect = element.getBoundingClientRect();
        return rect.top <= headerHeight + 10; // 10px de margen adicional
    };

    // Configuración de la detección de Intersection Observer
    const setupScrollObserver = () => {
        // Obtener la altura del header
        const headerHeight = document.querySelector('header') ? 
            document.querySelector('header').offsetHeight : 80;
        
        const options = {
            root: null,
            rootMargin: `-${headerHeight}px 0px 150px 0px`,
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0] // Más thresholds para detección más precisa
        };
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const eventId = entry.target.getAttribute('data-event-id');
                
                if (entry.isIntersecting) {
                    if (eventId) {
                        // Basta con que sea mínimamente visible para activarlo
                        if (entry.intersectionRatio >= 0.2) {
                            // Comprobar si está cerca del header
                            if (!isElementNearHeader(entry.target)) {
                                // TEMPORALMENTE COMENTADO PARA DEBUG
                                // setActiveEvent(eventId);
                                entry.target.classList.add('active');
                            }
                        }
                    }
                } else {
                    // Verificar si el punto está cerca del borde superior (header)
                    const isNearHeader = isElementNearHeader(entry.target);
                    
                    // Solo desactivar si está cerca del header
                    if (isNearHeader) {
                        entry.target.classList.remove('active');
                        
                        // Si este era el evento activo, desactivarlo
                        if (activeEvent === eventId) {
                            // TEMPORALMENTE COMENTADO PARA DEBUG
                            // setActiveEvent(null);
                        }
                    }
                }
            });
        }, options);
        
        // Observar todos los puntos de evento (incluyendo eventos compartidos) con un pequeño delay para asegurar que el DOM esté listo
        setTimeout(() => {
            document.querySelectorAll('.timeline-event-point, .shared-event-point').forEach(point => {
                observer.observe(point);
            });
        }, 100);
        
        return observer;
    };
    
    // Función para renderizar las líneas de personajes
    const renderCharacterLines = () => {
        const characterTypes = ['sc', 'corvus', 'era', 'tana', 'amber'];
        
        return (
            <div className="character-lines">
                {characterTypes.map(characterType => {
                    // Línea de eras siempre visible, otras según filtros
                    const isVisible = characterType === 'era' ? true : activeFilters.includes(characterType);
                    
                    return (
                        <div 
                            key={characterType}
                            className={`character-line ${characterType}`}
                            style={{
                                opacity: isVisible ? 1 : 0.3
                            }}
                        />
                    );
                })}
                
                {/* Puntos de conexión para eventos compartidos */}
                {getSharedEvents.map((sharedEvent, index) => {
                    const eventElement = document.querySelector(`[data-year="${sharedEvent.year}"]`);
                    if (!eventElement) return null;
                    
                    const rect = eventElement.getBoundingClientRect();
                    const timelineRect = timelineRef.current?.getBoundingClientRect();
                    
                    if (!timelineRect) return null;
                    
                    const top = rect.top - timelineRect.top;
                    
                    return (
                        <div key={`connection-${index}`}>
                            <div 
                                className="connection-line"
                                style={{ 
                                    top: `${top}px`,
                                    width: '60px'
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    // NUEVA FUNCIÓN: Renderizar línea resumen de navegación rápida
    const renderTimelineSummary = useMemo(() => {
        if (!timelineEvents || timelineEvents.length === 0) return null;

        // FILTRAR EVENTOS PARA MOSTRAR SOLO LOS MÁS IMPORTANTES
        const getImportantEvents = () => {
            const importantEvents = [];
            
            // 1. Incluir separadores de era (filtrar por búsqueda si está activa)
            timelineEvents.forEach((event, index) => {
                if (event.type === 'era-separator') {
                    // Aplicar filtro de búsqueda si existe
                    if (searchTerm.trim()) {
                        const searchLower = searchTerm.toLowerCase();
                        const searchableText = [
                            event.era || '',
                            event.description || '',
                            event.year?.toString() || ''
                        ].join(' ').toLowerCase();
                        
                        if (searchableText.includes(searchLower)) {
                            importantEvents.push({ event, index });
                        }
                    } else {
                        // Sin filtro de búsqueda, incluir todos
                        importantEvents.push({ event, index });
                    }
                }
            });

            // 2. Eventos clave por personaje y SC importantes
            const eventsByType = {
                sc: [],
                corvus: [],
                tana: [],
                amber: []
            };

            // Agrupar eventos por tipo Y aplicar filtro de búsqueda
            timelineEvents.forEach((event, index) => {
                if (event.type !== 'era-separator' && eventsByType[event.type]) {
                    // Aplicar filtro de búsqueda si existe
                    if (searchTerm.trim()) {
                        const searchLower = searchTerm.toLowerCase();
                        const searchableText = [
                            event.title || '',
                            event.content || '',
                            event.year?.toString() || '',
                            event.era || ''
                        ].join(' ').toLowerCase();
                        
                        if (searchableText.includes(searchLower)) {
                            eventsByType[event.type].push({ event, index });
                        }
                    } else {
                        // Sin filtro de búsqueda, incluir todos
                        eventsByType[event.type].push({ event, index });
                    }
                }
            });

            // CRITERIOS ESPECÍFICOS PARA CADA TIPO
            
            // Para personajes: TODOS los eventos son relevantes (SOLO si están activos en filtros)
            ['corvus', 'tana', 'amber'].forEach(type => {
                if (eventsByType[type] && activeFilters.includes(type)) {
                    eventsByType[type].forEach(eventData => {
                        importantEvents.push(eventData);
                    });
                }
            });

            // Para Star Citizen: SOLO eventos muy importantes (SOLO si SC está activo en filtros)
            if (eventsByType.sc && activeFilters.includes('sc')) {
                eventsByType.sc.forEach(eventData => {
                    const { event } = eventData;
                    const title = (event.title || '').toLowerCase();
                    const content = (event.content || '').toLowerCase();
                    
                    // Palabras clave que indican eventos importantes
                    const importantKeywords = [
                        // Guerras y conflictos
                        'guerra', 'war', 'batalla', 'battle', 'invasión', 'invasion', 
                        'conflicto', 'conflict', 'ataque', 'attack',
                        
                        // Razas y descubrimientos
                        'tevarin', 'vanduul', 'xi.an', 'xian', 'banu', 'kr.thak', 'krthak',
                        'descubrimiento', 'discovery', 'primer contacto', 'first contact',
                        'exterminio', 'extermination', 'extinción', 'extinction',
                        
                        // Sistemas y exploración
                        'sistema', 'system', 'jump point', 'punto de salto', 'colonización',
                        'colonization', 'terra', 'stanton', 'pyro', 'nyx',
                        
                        // Gobierno y política
                        'imperator', 'emperador', 'emperor', 'gobierno', 'government',
                        'uee', 'une', 'election', 'elección', 'regime', 'régimen',
                        'messer', 'dinastía', 'dynasty', 'dictadura', 'dictatorship',
                        
                        // Eventos tecnológicos/sociales importantes
                        'terraforming', 'terraformación', 'citizenship', 'ciudadanía',
                        'synthworld', 'synthmundo', 'ark starmap', 'quantum'
                    ];
                    
                    // Verificar si contiene palabras clave importantes
                    const isImportant = importantKeywords.some(keyword => 
                        title.includes(keyword) || content.includes(keyword)
                    );
                    
                    if (isImportant) {
                        importantEvents.push(eventData);
                    }
                });
            }

            // Ordenar por índice original para mantener orden cronológico
            return importantEvents.sort((a, b) => a.index - b.index);
        };

        const importantEvents = getImportantEvents();
        const totalImportant = importantEvents.length;

        // Barra de eventos: posición por ÍNDICE (orden cronológico), sin tocar la barra temporal
        const getPosition = (eventIndex, total) => {
            if (total <= 1) return eventIndex === 0 ? 0 : 100;
            return (eventIndex / (total - 1)) * 100;
        };

        // Segmentos de era por ÍNDICE (como siempre)
        const eraSegmentIndices = importantEvents
            .map((ed, i) => (ed.event.type === 'era-separator' ? i : -1))
            .filter((i) => i >= 0);
        const eraSegments = eraSegmentIndices.map((_, j) => {
            const start = getPosition(eraSegmentIndices[j], totalImportant);
            const end = j + 1 < eraSegmentIndices.length
                ? getPosition(eraSegmentIndices[j + 1], totalImportant)
                : 100;
            return {
                era: importantEvents[eraSegmentIndices[j]].event.era,
                top: start,
                height: Math.max(end - start, 2)
            };
        });

        // Barra de sistemas: seguir los años de los EVENTOS (posición = donde aparece ese año en el timeline)
        const eventsWithYears = importantEvents.map((ed, i) => ({ index: i, year: Number(ed.event?.year) }));
        const yearToPositionOnEventBar = (y) => {
            const year = Number(y);
            if (!Number.isFinite(year) || eventsWithYears.length === 0) return 0;
            const sorted = [...eventsWithYears].filter(e => Number.isFinite(e.year)).sort((a, b) => a.year - b.year);
            if (sorted.length === 0) return 0;
            const p0 = getPosition(sorted[0].index, totalImportant);
            const pLast = getPosition(sorted[sorted.length - 1].index, totalImportant);
            if (year <= sorted[0].year) return p0;
            if (year >= sorted[sorted.length - 1].year) return pLast;
            for (let i = 0; i < sorted.length - 1; i++) {
                if (sorted[i].year <= year && year <= sorted[i + 1].year) {
                    const t = (year - sorted[i].year) / (sorted[i + 1].year - sorted[i].year);
                    const posA = getPosition(sorted[i].index, totalImportant);
                    const posB = getPosition(sorted[i + 1].index, totalImportant);
                    return posA + t * (posB - posA);
                }
            }
            return p0;
        };
        const discoveries = getSystemDiscoveries();
        const discoveryMarkers = discoveries.map((d) => ({
            ...d,
            topPercent: Math.max(0, Math.min(100, yearToPositionOnEventBar(d.year)))
        }));

        // Obtener color por tipo
        const getEventColor = (type) => {
            switch(type) {
                case 'sc': return '#4169E1';
                case 'corvus': return '#B8860B';
                case 'tana': return '#DC143C';
                case 'amber': return '#87CEEB';
                case 'era-separator': return '#666666';
                default: return '#666666';
            }
        };

        return (
            <div className="timeline-summary">
                {/* Leyenda de colores */}
                <div className="timeline-summary-legend">
                    <div className="legend-title">{t('lore.legend.title', 'Eventos')}</div>
                    <div 
                        className={`legend-item ${activeFilters.includes('sc') ? 'active' : 'inactive'}`}
                        onClick={() => {
                            const newFilters = activeFilters.includes('sc')
                                ? activeFilters.filter(f => f !== 'sc')
                                : [...activeFilters, 'sc'];
                            setActiveFilters(newFilters);
                        }}
                    >
                        <div className="legend-color" style={{backgroundColor: '#4169E1'}}></div>
                        <span>Star Citizen</span>
                    </div>
                    <div 
                        className={`legend-item ${activeFilters.includes('corvus') ? 'active' : 'inactive'}`}
                        onClick={() => {
                            const newFilters = activeFilters.includes('corvus')
                                ? activeFilters.filter(f => f !== 'corvus')
                                : [...activeFilters, 'corvus'];
                            setActiveFilters(newFilters);
                        }}
                    >
                        <div className="legend-color" style={{backgroundColor: '#B8860B'}}></div>
                        <span>Palar Nest</span>
                    </div>
                    <div 
                        className={`legend-item ${activeFilters.includes('tana') ? 'active' : 'inactive'}`}
                        onClick={() => {
                            const newFilters = activeFilters.includes('tana')
                                ? activeFilters.filter(f => f !== 'tana')
                                : [...activeFilters, 'tana'];
                            setActiveFilters(newFilters);
                        }}
                    >
                        <div className="legend-color" style={{backgroundColor: '#DC143C'}}></div>
                        <span>Tana Novachek</span>
                    </div>
                    <div 
                        className={`legend-item ${activeFilters.includes('amber') ? 'active' : 'inactive'}`}
                        onClick={() => {
                            const newFilters = activeFilters.includes('amber')
                                ? activeFilters.filter(f => f !== 'amber')
                                : [...activeFilters, 'amber'];
                            setActiveFilters(newFilters);
                        }}
                    >
                        <div className="legend-color" style={{backgroundColor: '#87CEEB'}}></div>
                        <span>Amber Koshobe</span>
                    </div>
                    <div className="legend-item always-active">
                        <div className="legend-color" style={{backgroundColor: '#666666'}}></div>
                        <span>Eras</span>
                    </div>
                    
                    {/* Buscador integrado */}
                    <div className={`integrated-search ${searchTerm ? 'has-results' : ''}`}>
                        <div className="search-input-container">
                            <input
                                type="text"
                                placeholder={t('lore.search.placeholder', 'Buscar...')}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className={`search-input ${searchTerm ? 'has-content' : ''}`}
                            />
                            <button
                                onClick={() => setSearchTerm('')}
                                className="clear-search"
                            >
                                <FaTimes />
                            </button>
                        </div>
                        <div className="search-info">
                                                            {filteredEvents.filter(e => e.type !== 'era-separator').length} {t('lore.search.resultsCount', 'eventos')}
                        </div>
                    </div>
                </div>

                {/* Barra de sistemas: un punto = año de descubrimiento (como eventos pero en su propia barra) */}
                <div className="timeline-summary-discovery-bar" aria-label="Año de descubrimiento de cada sistema">
                    <div className="timeline-summary-discovery-title">{t('lore.discoveryBar.title', 'Sistemas')}</div>
                    <div className="timeline-summary-discovery-track" />
                    {discoveryMarkers.map((d, idx) => {
                        const markerColor = DISCOVERY_SYSTEM_COLORS[d.systemType] || DISCOVERY_SYSTEM_COLORS.unclaimed;
                        return (
                        <div
                            key={`${d.systemId}-${d.year}-${idx}`}
                            className="timeline-summary-discovery-marker"
                            style={{
                                top: `${d.topPercent}%`,
                                backgroundColor: markerColor,
                                boxShadow: `0 0 8px ${markerColor}99, 0 0 0 2px rgba(255, 255, 255, 0.4)`
                            }}
                            title={`${d.year}: ${d.systemName}`}
                        >
                            <span className="timeline-summary-discovery-label">{d.year} {d.systemName}</span>
                        </div>
                        );
                    })}
                </div>

                {/* Barra lateral de eras */}
                <div className="timeline-summary-era-bar" aria-label="Eras de la línea temporal">
                    {eraSegments.map((seg, idx) => (
                        <div
                            key={idx}
                            className="timeline-summary-era-segment"
                            style={{
                                top: `${seg.top}%`,
                                height: `${seg.height}%`
                            }}
                            title={seg.era}
                        >
                            <span className="timeline-summary-era-label">{seg.era}</span>
                        </div>
                    ))}
                </div>
                
                <div className="timeline-summary-line"></div>
                {importantEvents.map((eventData, summaryIndex) => {
                    const { event, index: originalIndex } = eventData;
                    const position = getPosition(summaryIndex, totalImportant);
                    const color = getEventColor(event.type);
                    const isActive = parseInt(activeEvent) === originalIndex;
                    
                    return (
                        <div
                            key={originalIndex}
                            className={`timeline-summary-point ${isActive ? 'active' : ''}`}
                            style={{
                                top: `${position}%`,
                                backgroundColor: color,
                                borderColor: color,
                                left: isActive ? '50px' : '46px' /* Sobre la línea de eventos */
                            }}
                            data-tooltip={`${event.year}: ${event.title || event.era}`}
                            onClick={() => handleEventClick(originalIndex)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.width = '30px';
                                e.currentTarget.style.transform = 'translateY(-50%)'; /* Solo centrado vertical */
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.width = '20px';
                                e.currentTarget.style.transform = 'translateY(-50%)'; /* Solo centrado vertical */
                            }}
                        >
                            <span className="timeline-summary-tooltip">
                                <strong>{event.year}</strong><br/>
                                {event.title || event.era}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    }, [timelineEvents, activeEvent, activeFilters, searchTerm]);
    
    // Renderizar cada evento del timeline
    // Función para agrupar eventos por año
    const groupEventsByYear = () => {
        const groupedEvents = {};
        
        filteredEvents.forEach((event, filteredIndex) => {
            if (event.type === 'era-separator') {
                // Los separadores de era van en su año específico
                const yearKey = `era-${event.year}`;
                groupedEvents[yearKey] = [event];
            } else {
                // Agrupar eventos por año
                const year = event.year;
                if (!groupedEvents[year]) {
                    groupedEvents[year] = [];
                }
                // Añadir el evento con su índice real en timelineEvents
                const realIndex = timelineEvents.findIndex(e => e.eventKey === event.eventKey);
                const eventWithIndex = {
                    ...event,
                    realIndex: realIndex !== -1 ? realIndex : 0
                };
                groupedEvents[year].push(eventWithIndex);
            }
        });
        
        return groupedEvents;
    };

    const renderEventCarousel = (events, yearKey) => {
        const year = events[0].year;
        const keyStr = String(yearKey);
        const rawIndex = carouselStates[keyStr] ?? carouselStates[yearKey] ?? 0;
        const currentEventIndex = Math.max(0, Math.min(rawIndex, events.length - 1));
        
        const currentEvent = events[currentEventIndex];
        const index = currentEvent.realIndex || 0;
        const isOdd = index % 2 !== 0;
        
        const nextEvent = () => {
            const newIndex = (currentEventIndex + 1) % events.length;
            const newEvent = events[newIndex];
            
            // Actualizar estado del carrusel y evento activo inmediatamente
            setCarouselStates(prev => ({
                ...prev,
                [yearKey]: newIndex
            }));
            setActiveEvent(newEvent.realIndex.toString());
        };
        
        const prevEvent = () => {
            const newIndex = (currentEventIndex - 1 + events.length) % events.length;
            const newEvent = events[newIndex];
            
            // Actualizar estado del carrusel y evento activo inmediatamente
            setCarouselStates(prev => ({
                ...prev,
                [yearKey]: newIndex
            }));
            setActiveEvent(newEvent.realIndex.toString());
        };

        // Verificar si el evento actual está activo
        const isActive = activeEvent === index.toString();
        const eraInfo = getEraForYear(year);
        const isDetailOnRight = currentEvent.type === 'sc' || currentEvent.type === 'corvus';

                return (
            <div 
                key={`${yearKey}-${currentEventIndex}`}
                className="timeline-event event-carousel"
                data-type={currentEvent.type}
                data-index={index}
                data-year={year}
                data-event-key={currentEvent.eventKey}
            >
                {/* Punto en la timeline */}
                <div 
                    className={`timeline-event-point ${isActive ? 'active' : ''}`}
                    data-event-id={index}
                    data-tooltip={t('lore.labels.clickToView')}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEventClick(index);
                    }}
                >
                    {getEventIcon(currentEvent)}
                </div>
                
                {/* Referencia de era en el lado contrario al evento */}
                {eraInfo.era && (
                    <div className={`event-era-reference ${isDetailOnRight ? 'event-era-reference-left' : 'event-era-reference-right'}`}>
                        <h2 className="event-era-reference-title">{eraInfo.era}</h2>
                        <p className="event-era-reference-description">{eraInfo.description}</p>
                    </div>
                )}
                
                <div className={`event-year ${isOdd ? 'right-align' : 'left-align'}`}>
                    {year}
                </div>
                
                {/* Tarjeta del evento */}
                <div 
                    className={`event-detail ${isActive ? 'active' : ''}`}
                    onMouseEnter={() => handleDetailHover(index, true)}
                    onMouseLeave={() => handleDetailHover(index, false)}
                    onClick={(e) => handleDetailClick(index, e)}
                >
                    <div className="event-header">
                        <h3 className="event-title">
                            <span className="event-year-title">{year}</span>{' '}
                            {currentEvent.title}
                        </h3>
                        <div className="event-badges">
                            {Array.isArray(currentEvent.image) ? (
                                // Si hay múltiples imágenes, mostrar etiquetas de ambos personajes
                                <>
                                    <span className="event-badge corvus">
                                        {t('lore.labels.palarNest')}
                                    </span>
                                    <span className="event-badge tana">
                                        {t('lore.labels.tanaNovachek')}
                                    </span>
                                </>
                            ) : (
                                // Si hay una sola imagen, mostrar la etiqueta del personaje correspondiente
                                <span className={`event-badge ${currentEvent.type}`}>
                                    {currentEvent.type === 'corvus' 
                                        ? t('lore.labels.palarNest') 
                                        : currentEvent.type === 'tana'
                                        ? t('lore.labels.tanaNovachek')
                                        : currentEvent.type === 'amber'
                                        ? t('lore.labels.amberKoshobe')
                                        : t('lore.labels.starCitizen')}
                                </span>
                            )}
                        </div>
                    </div>
                    
                    {currentEvent.image && (
                        <div className="event-image-container" 
                            data-name={currentEvent.title}
                        >
                            {Array.isArray(currentEvent.image) ? (
                                <div className="multiple-images">
                                    {currentEvent.image.map((img, idx) => (
                                        <img 
                                            key={`${currentEvent.eventKey}-${currentEventIndex}-${idx}`}
                                            src={img} 
                                            alt={`${currentEvent.title} - Personaje ${idx + 1}`} 
                                            className="event-image" 
                                            loading="eager" 
                                            fetchpriority="high"
                                            onLoad={() => {
                                                // Imagen cargada correctamente
                                            }}
                                            onError={(e) => {
                                                console.error(`Error cargando imagen para: ${currentEvent.title} - Personaje ${idx + 1}`, e);
                                            }}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <img 
                                    key={`${currentEvent.eventKey}-${currentEventIndex}`}
                                    src={currentEvent.image} 
                                    alt={currentEvent.title}
                                    className="event-image"
                                    onLoad={() => {
                                        console.log(`Imagen cargada para: ${currentEvent.title}`);
                                    }}
                                    onError={(e) => {
                                        console.error(`Error cargando imagen para: ${currentEvent.title}`, e);
                                    }}
                                />
                            )}
                        </div>
                    )}
                    
                    <div className="event-content">
                        <p>{currentEvent.content}</p>
                    </div>
                </div>
                
                {/* Controles del carrusel */}
                {events.length > 1 && (
                    <div className="carousel-controls">
                        <button 
                            className="carousel-btn prev-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                prevEvent();
                            }}
                            title="Evento anterior del mismo año"
                            type="button"
                        >
                            ‹
                        </button>
                        <button 
                            className="carousel-btn next-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                nextEvent();
                            }}
                            title="Siguiente evento del mismo año"
                            type="button"
                        >
                            ›
                        </button>
                    </div>
                )}
                
                {/* Controles del carrusel */}
                {events.length > 1 && (
                    <div className="carousel-controls">
                        <button 
                            className="carousel-btn prev-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                prevEvent();
                            }}
                            title="Evento anterior del mismo año"
                            type="button"
                        >
                            ‹
                        </button>
                        <button 
                            className="carousel-btn next-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                nextEvent();
                            }}
                            title="Siguiente evento del mismo año"
                            type="button"
                        >
                            ›
                        </button>
                    </div>
                )}
            </div>
        );
    };

    const renderTimelineEvents = () => {
        const groupedEvents = groupEventsByYear();
        
        // Ordenar las claves cronológicamente
        const sortedKeys = Object.keys(groupedEvents).sort((a, b) => {
            // Extraer el año de las claves de era
            let yearA, yearB;
            
            if (a.startsWith('era-')) {
                yearA = parseInt(a.replace('era-', ''));
            } else {
                yearA = parseInt(a);
            }
            
            if (b.startsWith('era-')) {
                yearB = parseInt(b.replace('era-', ''));
            } else {
                yearB = parseInt(b);
            }
            
            // Ordenar por año (cronológicamente)
            return yearA - yearB;
        });
        
        return sortedKeys.map((key) => {
            const events = groupedEvents[key];
            // Si es un separador de era
            if (key.startsWith('era-')) {
                const event = events[0];
                const eraIndex = timelineEvents.findIndex(e => 
                    e.type === 'era-separator' && e.year === event.year
                );
                const isActive = activeEvent === eraIndex.toString();
                
                return (
                    <div 
                        key={key} 
                        className="era-separator"
                        data-index={eraIndex}
                        data-year={event.year}
                    >
                        <div className="era-marker"></div>
                        <div className="era-details">
                            <h2 className="era-title">{event.era}</h2>
                            <p className="era-description">{event.description}</p>
                        </div>
                        {/* Punto central de era */}
                        <div className="era-timeline-points">
                            <div 
                                className={`era-point era-center-point ${isActive ? 'active' : ''}`}
                                data-event-id={eraIndex}
                                data-tooltip={t('lore.labels.clickToView')}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEventClick(eraIndex);
                                }}
                            ></div>
                        </div>
                    </div>
                );
            }

            // Si hay múltiples eventos en el mismo año, crear carrusel
            if (events.length > 1) {
                return renderEventCarousel(events, key);
            }
            


            // Evento individual
            const event = events[0];
            const index = event.realIndex || 0;
            const isOdd = index % 2 !== 0;
            const eventKey = event.eventKey || `event-${index}`;
            const eraInfo = getEraForYear(event.year);
            const isDetailOnRight = event.type === 'sc' || event.type === 'corvus';
            
            return (
                <div 
                    key={eventKey}
                    className={`timeline-event ${Array.isArray(event.image) ? 'shared-event' : ''}`}
                    data-type={event.type}
                    data-index={index}
                    data-year={event.year}
                    data-event-key={event.eventKey}
                >
                    {Array.isArray(event.image) ? (
                        // Si hay múltiples imágenes, mostrar puntos en ambas líneas
                        <>
                            <div 
                                className={`shared-event-point corvus-point ${activeEvent === index.toString() ? 'active' : ''}`}
                                data-event-id={index}
                                data-tooltip={t('lore.labels.clickToView')}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEventClick(index);
                                }}
                            >
                                {getEventIcon(event)}
                            </div>
                            <div 
                                className={`shared-event-point tana-point ${activeEvent === index.toString() ? 'active' : ''}`}
                                data-event-id={index}
                                data-tooltip={t('lore.labels.clickToView')}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEventClick(index);
                                }}
                            >
                                {getEventIcon(event)}
                            </div>
                        </>
                    ) : (
                        // Si hay una sola imagen, mostrar solo un punto
                    <div 
                        className={`timeline-event-point ${activeEvent === index.toString() ? 'active' : ''}`}
                        data-event-id={index}
                        data-tooltip={t('lore.labels.clickToView')}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEventClick(index);
                        }}
                    >
                        {getEventIcon(event)}
                    </div>
                    )}
                    
                    {/* Referencia de era en el lado contrario al evento */}
                    {eraInfo.era && (
                        <div className={`event-era-reference ${isDetailOnRight ? 'event-era-reference-left' : 'event-era-reference-right'}`}>
                            <h2 className="event-era-reference-title">{eraInfo.era}</h2>
                            <p className="event-era-reference-description">{eraInfo.description}</p>
                        </div>
                    )}
                    
                    <div className={`event-year ${isOdd ? 'right-align' : 'left-align'}`}>
                        {event.year}
                    </div>
                    
                    <div 
                        className={`event-detail ${Array.isArray(event.image) ? 'shared-event-detail' : ''} ${activeEvent === index.toString() ? 'active' : ''}`}
                        onMouseEnter={() => handleDetailHover(index, true)}
                        onMouseLeave={() => handleDetailHover(index, false)}
                        onClick={(e) => handleDetailClick(index, e)}
                    >
                        <div className="event-header">
                            <h3 className="event-title">
                                <span className="event-year-title">{event.year}</span>{' '}
                                {event.title}
                            </h3>
                            <div className="event-badges">
                                {Array.isArray(event.image) ? (
                                    // Si hay múltiples imágenes, mostrar etiquetas de ambos personajes
                                    <>
                                        <span className="event-badge corvus">
                                            {t('lore.labels.palarNest')}
                                        </span>
                                        <span className="event-badge tana">
                                            {t('lore.labels.tanaNovachek')}
                                        </span>
                                    </>
                                ) : (
                                    // Si hay una sola imagen, mostrar la etiqueta del personaje correspondiente
                                    <span className={`event-badge ${event.type}`}>
                                {event.type === 'corvus' 
                                            ? t('lore.labels.palarNest') 
                                            : event.type === 'tana'
                                            ? t('lore.labels.tanaNovachek')
                                            : event.type === 'amber'
                                            ? t('lore.labels.amberKoshobe')
                                    : t('lore.labels.starCitizen')}
                            </span>
                                )}
                            </div>
                        </div>
                        
                        {event.image && (
                            <div className="event-image-container" 
                                data-name={event.title}
                            >
                                {Array.isArray(event.image) ? (
                                    <div className="multiple-images">
                                        {event.image.map((img, idx) => (
                                            <img 
                                                key={idx}
                                                src={img} 
                                                alt={`${event.title} - Personaje ${idx + 1}`} 
                                                className="event-image" 
                                                loading="eager" 
                                                fetchpriority="high"
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <img 
                                        src={event.image} 
                                        alt={event.title} 
                                        className="event-image" 
                                        loading="eager" 
                                        fetchpriority="high"
                                    />
                                )}
                            </div>
                        )}
                        
                        <div className="event-content">
                            <p>{event.content}</p>
                        </div>
                    </div>
                </div>
            );
        });
    };

    // Función para añadir texto curvado a las imágenes
    useEffect(() => {
        // Pre-renderizar los detalles para evitar retrasos en la carga
        const preloadEventDetails = () => {
            // Recorrer todos los eventos y "simular" un hover para que se precargen las traducciones
            timelineEvents.forEach((event, index) => {
                if (event.type !== 'era-separator' && event.eventKey) {
                    // Precargar las traducciones de títulos
                    if (event.eventKey) {
                        t(event.eventKey, { returnObjects: true });
                    }
                    
                    // Precargar las traducciones de contenido
                    if (event.content && event.content.startsWith('lore.')) {
                        const contentKey = event.content;
                        t(contentKey, { returnObjects: true });
                        
                        // También precargar las partes adicionales si existen
                        const contentBase = contentKey.substring(0, contentKey.lastIndexOf('.') + 1);
                        let i = 2;
                        while (i <= 5) { // Limitar a un máximo razonable
                            const additionalKey = `${contentBase}content${i}`;
                            t(additionalKey, { defaultValue: '' });
                            i++;
                        }
                    }
                }
            });
        };
        
        const addCurvedText = () => {
            const textContainers = document.querySelectorAll('.event-image-container');
            textContainers.forEach(container => {
                if (!container.getAttribute('data-name')) return;
                
                // Eliminar SVG previos si existen
                const oldSvg = container.querySelector('svg');
                if (oldSvg) {
                    oldSvg.remove();
                }
                
                // Crear SVG para texto curvo
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                
                // Crear un camino para el texto
                const textPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
                const containerWidth = 150; // Ancho del contenedor de la imagen
                
                // Calcular el radio para el path (un poco más grande que la imagen)
                const radius = containerWidth / 2 + 15;
                
                // Crear un arco para la parte inferior
                const pathData = `M 20,${radius * 1.2} A ${radius},${radius} 0 0,1 ${containerWidth - 20},${radius * 1.2}`;
                textPath.setAttribute("d", pathData);
                textPath.setAttribute("id", `textPath-${container.getAttribute('data-name').replace(/\s+/g, '-').toLowerCase()}`);
                textPath.setAttribute("fill", "none");
                svg.appendChild(textPath);
                
                // Crear el texto que seguirá el camino
                const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
                text.setAttribute("class", "curve-text");
                
                // Crear referencia al camino
                const textPathRef = document.createElementNS("http://www.w3.org/2000/svg", "textPath");
                textPathRef.setAttribute("href", `#textPath-${container.getAttribute('data-name').replace(/\s+/g, '-').toLowerCase()}`);
                textPathRef.setAttribute("startOffset", "50%");
                textPathRef.setAttribute("text-anchor", "middle");
                textPathRef.textContent = container.getAttribute('data-name');
                
                text.appendChild(textPathRef);
                svg.appendChild(text);
                
                // Añadir el SVG al contenedor
                container.appendChild(svg);
            });
        };
        
        // Establecer un evento activo por defecto (para que siempre haya algo visible)
        const setInitialActiveEvent = () => {
            // Solo ejecutar una vez
            if (hasInitialized.current) return;
            
            // Primero buscar si ya hay un evento activo por URL o context
            if (activeEvent !== null) return;
            
            // Buscar la Era Antigua (que ahora es el primer elemento del timeline)
            for (let i = 0; i < timelineEvents.length; i++) {
                if (timelineEvents[i].type === 'era-separator' && timelineEvents[i].year === -1000000) {
                    setActiveEvent(i.toString());
                    
                    // Hacer scroll hacia arriba para que se vean los filtros
                    setTimeout(() => {
                        const element = document.querySelector(`[data-index="${i}"]`);
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        } else {
                            // Si no encuentra el elemento, hacer scroll al top de la página
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                    }, 100);
                    
                    // Marcar como inicializado
                    hasInitialized.current = true;
                    break;
                }
            }
        };
        
        // Ejecutar todo de manera organizada para optimizar el rendimiento
        const initTimeline = async () => {
            // Primero, precargar las traducciones y textos
            preloadEventDetails();
            
            // Pequeño delay para asegurar que el DOM esté listo (usar requestAnimationFrame es más eficiente)
            requestAnimationFrame(() => {
                // Luego, establecer el evento activo inicial
                setInitialActiveEvent();
                
                // Finalmente, añadir los textos curvos
                addCurvedText();
                
                // Configurar el observer después de todo lo demás
                const observer = setupScrollObserver();
                
                // Guardar el observer para limpieza
                window.timelineObserver = observer;
            });
        };
        
        // Iniciar el timeline
        initTimeline();
        
        // Limpiar al desmontar
        return () => {
            const svgs = document.querySelectorAll('.event-image-container svg');
            svgs.forEach(svg => svg.remove());
            if (window.timelineObserver) {
                window.timelineObserver.disconnect();
                delete window.timelineObserver;
            }
        };
    }, [t, timelineEvents, activeEvent]);

    return (
        <div className="lore-page" style={{ 
            backgroundColor: (
                activeEvent === specialEventIndices.birth?.toString() || 
                activeEvent === specialEventIndices.franklinMeeting?.toString() ||
                activeEvent === specialEventIndices.franklinAttack?.toString() ||
                activeEvent === specialEventIndices.firstContract?.toString() ||
                activeEvent === specialEventIndices.oberonCrisis?.toString() ||
                activeEvent === specialEventIndices.corvusCorax?.toString() ||
                activeEvent === specialEventIndices.oretaniOperations?.toString() ||

                activeEvent === specialEventIndices.pyroAmbush?.toString() ||
                activeEvent === specialEventIndices.magnusMission?.toString() ||
                activeEvent === specialEventIndices.palarRetirement?.toString() ||
                activeEvent === specialEventIndices.magnusExpansion?.toString() ||
                activeEvent === specialEventIndices.firstAssembly?.toString() ||
                activeEvent === specialEventIndices.palarDeath?.toString() ||
                activeEvent === specialEventIndices.tanaLeadership?.toString() ||
                activeEvent === specialEventIndices.corvusConsolidation?.toString() ||
                activeEvent === specialEventIndices.tanaBirth?.toString() ||
                activeEvent === specialEventIndices.tanaAcademy?.toString() ||
                activeEvent === specialEventIndices.tanaExcellence?.toString() ||
                activeEvent === specialEventIndices.tanaGraduation?.toString() ||
                activeEvent === specialEventIndices.tanaIntelligence?.toString() ||
                activeEvent === specialEventIndices.tanaUndercover?.toString() ||
                activeEvent === specialEventIndices.tanaBetrayal?.toString() ||
                activeEvent === specialEventIndices.tanaMeetingPalar?.toString() ||
                activeEvent === specialEventIndices.tanaNocturnaFederation?.toString() ||
                activeEvent === specialEventIndices.tanaCollaboration?.toString() ||
                activeEvent === specialEventIndices.tanaRightHand?.toString() ||
                activeEvent === specialEventIndices.corvusPresent?.toString() ||
                activeEvent === specialEventIndices.amberBirth?.toString() ||
                activeEvent === specialEventIndices.amberEquivalence?.toString() ||
                activeEvent === specialEventIndices.amberCitizenship?.toString() ||
                activeEvent === specialEventIndices.amberService?.toString() ||
                activeEvent === specialEventIndices.amberEnrcFoundation?.toString() ||
                activeEvent === specialEventIndices.amberFcnCollaboration?.toString() ||
                activeEvent === specialEventIndices.amberTevarinWar?.toString() ||
                activeEvent === specialEventIndices.amberCorvusIntegration?.toString()
            ) ? 'transparent' : 'var(--dark)' 
        }}>
            {activeEvent === specialEventIndices.birth?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${nacimientoPalarNest})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.franklinMeeting?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${encuentroConFranklin})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.franklinAttack?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${ataqueAFranklin})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.firstContract?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${elPrimerContrato})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.corvusCorax?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${fundacionCorvusCorax})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.firstAssembly?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${primeraAsambleaCorvusNocta})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.pyroAmbush?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${laEmboscadaEnPyro})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}

            {activeEvent === specialEventIndices.newDirection?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${elNuevoRumbo})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.palarRetirement?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${retiroDePalarNest})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaLeadership?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${liderazgoTanaNovachek})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.oberonCrisis?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${oberonCrisis})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.magnusMission?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${magnusMission})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.magnusExpansion?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${magnusExpansion})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.palarDeath?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${palarNestImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.oretaniOperations?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${oretaniImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.corvusConsolidation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaConsolidation})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaBirth?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tana4Image})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaAcademy?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaAcademy})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaExcellence?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaAcademyExcellence})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaAcademy?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaAcademy})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaGraduation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaGraduationBg})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaIntelligence?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaInteligencia})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaUndercover?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaContrainteligencia})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaBetrayal?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaTraicion})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaMeetingPalar?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${encuentroConTanaNovachek})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaNocturnaFederation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaNoctaFederation})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaCollaboration?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${colaboracionTanaPalar})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaRightHand?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaManoDerechaImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.corvusPresent?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${corvusActualidadImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberBirth?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${koshobe4Image})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberEquivalence?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberEnlistImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberCitizenship?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberCampoBatallaImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberService?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberCiudadanoLabImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberEnrcFoundation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberFcnCollaboration?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberTevarinWar?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberCorvusIntegration?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}

            <div ref={headerRef} className="timeline-header-reference"></div>

            {/* Mapa estelar cuadrado ocultable - arriba a la derecha */}
            <div className={`starmap-top-panel ${rightPanelCollapsed ? 'starmap-top-panel-collapsed' : ''}`}>
                <button
                    type="button"
                    className="starmap-top-panel-toggle"
                    onClick={() => setRightPanelCollapsed(prev => !prev)}
                    title={rightPanelCollapsed ? t('lore.panelExpand', 'Mostrar mapa') : t('lore.panelCollapse', 'Ocultar mapa')}
                    aria-label={rightPanelCollapsed ? t('lore.panelExpand', 'Mostrar mapa') : t('lore.panelCollapse', 'Ocultar mapa')}
                >
                    <span className="starmap-top-panel-toggle-label">{t('lore.systemsPanelLabel', 'Sistemas')}</span>
                    {rightPanelCollapsed ? ' ‹' : ' ›'}
                </button>
                <div className="starmap-top-panel-content">
                    <div className="starmap-top-panel-inner">
                        <Starmap systems={starmapSystemsForYear} className="timeline-starmap" />
                    </div>
                </div>
            </div>

            <div className="timeline-container">
                <h1 className="timeline-title">{t('lore.timelineTitle', 'Línea Temporal')}</h1>
                
                <div className="timeline-line" ref={timelineRef}>
                    {renderCharacterLines()}
                    {renderTimelineEvents()}
                </div>
                
                {/* Línea resumen de navegación rápida */}
                {renderTimelineSummary}

                {/* Botones de navegación del timeline (como estaban antes) */}
                <div className="timeline-navigation">
                    <div className="nav-buttons-group">
                        <span className="nav-buttons-label copper">Timeline</span>
                        <div className="nav-buttons-container">
                            <button 
                                className="nav-button"
                                onClick={() => navigateEvents('prev')}
                                title={t('lore.navigation.previous', 'Evento anterior')}
                            >
                                ↑
                            </button>
                            <button 
                                className="nav-button"
                                onClick={() => navigateEvents('next')}
                                title={t('lore.navigation.next', 'Siguiente evento')}
                            >
                                ↓
                            </button>
                        </div>
                    </div>

                    {/* Contador del carrusel - solo aparece cuando hay múltiples eventos del mismo año */}
                    {(() => {
                        const groupedEvents = groupEventsByYear();
                        const carouselYears = Object.entries(groupedEvents)
                            .filter(([key, events]) => !key.startsWith('era-') && events.length > 1);
                        
                        if (carouselYears.length > 0) {
                            const activeEventIndex = parseInt(activeEvent) || 0;
                            const activeCarousel = carouselYears.find(([yearKey, events]) => {
                                return events.some(event => event.realIndex === activeEventIndex);
                            });
                            
                            if (activeCarousel) {
                                const [yearKey, events] = activeCarousel;
                                const currentIndex = carouselStates[yearKey] || 0;
                                
                                return (
                                    <div className="carousel-indicator" style={{
                                        position: 'absolute',
                                        right: '25px',
                                        top: '-30px',
                                        background: 'rgba(0, 0, 0, 0.9)',
                                        border: '2px solid var(--copper)',
                                        borderRadius: '15px',
                                        padding: '6px 12px',
                                        zIndex: 200,
                                        boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)'
                                    }}>
                                        <span className="carousel-counter">{currentIndex + 1} / {events.length}</span>
                                    </div>
                                );
                            }
                        }
                        return null;
                    })()}
                </div>

                {/* Componente de búsqueda */}
                {showSearch && (
                    <EventSearch 
                        onEventSelect={handleEventSelect}
                        onClose={handleCloseSearch}
                    />
                )}
            </div>
        </div>
    );
};
export default Lore;
